// Reflects com.wixpress.sm.domain.SiteMemberPrivacyStatus
export default {
  PRIVATE: 'PRIVATE',
  PUBLIC: 'PUBLIC',
  // Deprecated, should behave the same as "PUBLIC"
  COMMUNITY: 'COMMUNITY',
};
